import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCurrentSchoolYear, selectEstablishment } from '../redux/selectors/establishment.selectors';
import { selectAllEstablishmentFases } from '../redux/selectors/profile.selectors';
import { selectAllEstablishments } from '../redux/selectors/reference-data.selectors';
import { SchoolOrganizationActions } from '../redux/actions/school-organization.actions';
import { GridTemplateActions } from '../redux/actions/course-grid.actions';
import { StudentActions } from '../redux/actions/student.actions';
import { StudentGridActions } from '../redux/actions/student-grid.actions';
import { ReferenceFileActions } from '../redux/actions/reference-file.actions';
import Keycloak from 'keycloak-js';
import { AppFacadeService } from '../app-facade.service';
import { EstablishmentActions } from '../redux/actions/establishment.actions';

@Injectable({
  providedIn: 'root',
})
export class LayoutFacadeService {
  private store = inject(Store);
  private keycloak = inject(Keycloak);
  private appFacade = inject(AppFacadeService);

  selectedEstablishment$ = this.store.select(selectEstablishment);
  establishmentFases$ = this.store.select(selectAllEstablishmentFases);
  establishmentRef$ = this.store.select(selectAllEstablishments);
  currentSchoolYear$ = this.store.select(selectCurrentSchoolYear);

  establishmentFase(establishmentId: string) {
    this.appFacade.loadEstablishmentDetail(establishmentId);
    this.store.dispatch(SchoolOrganizationActions.reset());
    this.store.dispatch(GridTemplateActions.reset());
    this.store.dispatch(StudentActions.reset());
    this.store.dispatch(StudentGridActions.reset());
    this.store.dispatch(ReferenceFileActions.reset());
  }

  currentSchoolYear(schoolYear: number) {
    this.store.dispatch(EstablishmentActions.setSchoolYear({ schoolYear }));
    this.store.dispatch(SchoolOrganizationActions.reset());
    this.store.dispatch(GridTemplateActions.reset());
    this.store.dispatch(StudentActions.reset());
    this.store.dispatch(StudentGridActions.reset());
    this.store.dispatch(ReferenceFileActions.reset());
  }

  logout() {
    this.keycloak.logout();
  }

  get userName(): string | null {
    const tokenParsed = this.keycloak.tokenParsed as { given_name?: string, family_name?: string, email?: string } | undefined;

    const firstName = tokenParsed?.given_name || '';
    const lastName = tokenParsed?.family_name || '';
    const email = tokenParsed?.email || '';
    return `${firstName} ${lastName}`.trim() || email || 'Utilisateur';
  }
}
